<template>
  <onboarding-step>
    <template #heading>
      What race or ethnicity best describes you?
    </template>
    <template #content>
      <l-race-input
        v-model="user.race"
        class="label:sr-only help:sr-only"
        size="lg"
        placeholder="Select race/ethnicity"
      />
    </template>
    <template #subcontent>
      <img src="/images/illustration-sitting-2.svg" class="h-full w-auto py-16">
    </template>
  </onboarding-step>
</template>

<script setup>
import LRaceInput from "@/components/inputs/LRaceInput.vue"
import OnboardingStep from "@/components/onboardings/OnboardingStep.vue"

const user = defineModel({ type: Object, required: true })
</script>
